import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент индикатора цвета
 * Отображает квадрат с указанным цветом
 */
const ColorIndicator = ({ color, size = 16 }) => {
    return (_jsx("span", { style: {
            display: 'inline-block',
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: color,
            border: '1px solid #ccc',
            borderRadius: '2px',
            marginRight: '4px',
        }, "aria-label": `Цвет: ${color}` }));
};
export default ColorIndicator;
